import { Touch, TouchEvent, useRef } from 'react';

const DEFAULT_THRESHOLD = 50;

interface Props {
  threshold?: number;
  onSwipeUp?: () => void;
  onSwipeDown?: () => void;
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
}

export const useMobileSwipeNavigation = (props: Props) => {
  const { onSwipeUp, onSwipeDown, onSwipeLeft, onSwipeRight } = props;
  const { threshold = DEFAULT_THRESHOLD } = props;

  const touchStartRef = useRef<Touch>();

  // Mise à jour de la position initiale
  const onTouchStart = (event: TouchEvent) => {
    touchStartRef.current = event.changedTouches[0];
  };

  // Mesure des distances à la fin du swipe
  const onTouchEnd = (event: TouchEvent) => {
    const touchStart = touchStartRef.current;
    const touchEnd = event.changedTouches[0];
    if (!touchStart || !touchEnd) return;

    // Distance parcourue dans chaque direction
    const results = [
      { handler: onSwipeUp, distance: touchStart.screenY - touchEnd.screenY },
      { handler: onSwipeDown, distance: touchEnd.screenY - touchStart.screenY },
      { handler: onSwipeLeft, distance: touchStart.screenX - touchEnd.screenX },
      { handler: onSwipeRight, distance: touchEnd.screenX - touchStart.screenX },
    ];

    // Appel du handler correspondant à la plus grande distance parcourue (et > threshold)
    const filteredResults = results.filter(item => Math.abs(item.distance) > threshold);
    const sortedResults = filteredResults.sort((a, b) => b.distance - a.distance);
    const handler = sortedResults[0]?.handler;
    handler?.();
  };

  return { onTouchStart, onTouchEnd };
};
